DeliveryEstimates = window.DeliveryEstimates ?= {}

DeliveryEstimates.View = require './views/delivery_estimates'

DeliveryEstimates.init = ({deliveryEstimates}, done) ->
  return done() unless deliveryEstimates?

  $ ->
    new DeliveryEstimates.View
      deliveryEstimates: deliveryEstimates

    done()


module.exports = DeliveryEstimates
